module.exports = __webpack_public_path__ + "img/how-rpc-work-1.55029c0b.png";